import Layout from '@/pages/Layout';

export default [
    {
        path: '/system',
        redirect: 'noredirect',
        component: Layout,
        name: 'system',
        meta: {
            title: '系统中心',
            icon: 'el-icon-s-platform'
        },
        children: [
            {
                path: 'myCompany',
                component: () => import('@/pages/system/company/MyCompany'),
                // redirect: 'noredirect',
                name: 'myCompany',
                id: 'system/myCompany',
                meta: {
                    title: '我的企业',
                    icon: 'iconfont icon-other-wodeqiye bc-custom-menu',
                    color: '#fc0202'
                },
                isMenuWaterfall: true
            },
            /* { //转移到客服管理系统里
                path: 'company-auth',
                component: () => import('@/pages/system/company/CompanyAuth'),
                // redirect: 'noredirect',
                name: 'companyAuth',
                meta: {
                    title: '企业信息审核',
                    icon: 'beer'
                }
            }, */
            {
                path: 'company-add',
                component: () => import('@/pages/system/company/CompanyDetail'),
                isShow: false,
                name: 'companyAdd',
                id: 'system/company-add',
                meta: {
                    title: '添加企业',
                    icon: 'beer'
                },
                isMenuWaterfall: false
            },
            {
                path: '/company/:companyId',
                component: () => import('@/pages/system/company/CompanyDetail'),
                isShow: false,
                name: 'companyDetail',
                id: 'system/company/:companyId',
                meta: {
                    title: '企业详情',
                    icon: 'beer'
                },
                isMenuWaterfall: false
            },
            {
                path: 'department',
                component: () => import('@/pages/system/department/DepartmentList'),
                // redirect: 'noredirect',
                name: 'department',
                id: 'system/department',
                meta: {
                    title: '部门管理',
                    icon: 'iconfont icon-other-iconbmgl bc-custom-menu',
                    color: '#b2b109'
                },
                isMenuWaterfall: true
            },
            {
                path: 'department-add/:pId/:pName',
                component: () => import('@/pages/system/department/DepartmentDetail'),
                isShow: false,
                name: 'departmentAdd',
                id: 'system/department-add/:pId/:pName',
                meta: {
                    title: '添加部门',
                    icon: 'beer'
                },
                isMenuWaterfall: false
            },
            // {
            //     path: '/department/:departmentId',
            //     component: () => import('@/pages/system/department/DepartmentDetail'),
            //     isShow: false,
            //     name: 'departmentDetail',
            //     meta: {
            //         title: '部门详情',
            //         icon: 'beer'
            //     }
            // },
            {
                path: 'position',
                component: () => import('@/pages/system/position/PositionList'),
                // redirect: 'noredirect',
                name: 'position',
                id: 'system/position',
                meta: {
                    title: '岗位管理',
                    icon: 'iconfont icon-other-qiyeguanli_gangweiguanli bc-custom-menu',
                    color: '#76bae3'
                },
                isMenuWaterfall: true
            },
            {
                path: 'position-add/:pId/:pName',
                component: () => import('@/pages/system/position/PositionDetail'),
                isShow: false,
                name: 'positionAdd',
                id: 'system/position-add/:pId/:pName',
                meta: {
                    title: '添加岗位',
                    icon: 'beer'
                },
                isMenuWaterfall: false
            },
            // {
            //     path: '/position/:positionId',
            //     component: () => import('@/pages/system/position/PositionDetail'),
            //     isShow: false,
            //     name: 'positionDetail',
            //     meta: {
            //         title: '岗位详情',
            //         icon: 'beer'
            //     }
            // },
            {
                path: 'resource',
                component: () => import('@/pages/system/resource/ResourceList'),
                // redirect: 'noredirect',
                name: 'resource',
                id: 'system/resource',
                meta: {
                    title: '资源管理',
                    icon: 'iconfont icon-other-ziyuanguanli bc-custom-menu',
                    color: '#f8e931'
                },
                isMenuWaterfall: false
            },
            {
                path: 'resource-add/:pId/:pName',
                component: () => import('@/pages/system/resource/ResourceDetail'),
                isShow: false,
                name: 'resourceAdd',
                id: 'system/resource-add/:pId/:pName',
                meta: {
                    title: '添加资源',
                    icon: 'beer'
                },
                isMenuWaterfall: false
            },
            // {
            //     path: '/resource/:resourceId',
            //     component: () => import('@/pages/system/resource/ResourceDetail'),
            //     isShow: false,
            //     name: 'resourceDetail',
            //     meta: {
            //         title: '资源详情',
            //         icon: 'beer'
            //     }
            // },
            {
                path: 'employee',
                component: () => import('@/pages/system/employee/EmployeeList'),
                // redirect: 'noredirect',
                name: 'employee',
                id: 'system/employee',
                meta: {
                    title: '在职员工管理',
                    icon: 'iconfont icon-other-yuangongguanli bc-custom-menu',
                    color: '#67c23a'
                },
                isMenuWaterfall: true
            },
            {
                path: 'employee-add',
                component: () => import('@/pages/system/employee/EmployeeDetail'),
                isShow: false,
                name: 'employeeAdd',
                id: 'system/employee-add',
                meta: {
                    title: '添加员工',
                    icon: 'beer'
                },
                isMenuWaterfall: false
            },
            {
                path: 'employee-quitlist',
                component: () => import('@/pages/system/employee/EmployeeQuitList'),
                // redirect: 'noredirect',
                name: 'employee-quitlist',
                id: 'system/employee-quitlist',
                meta: {
                    title: '离职员工管理',
                    icon: 'iconfont icon-other-lizhi bc-custom-menu',
                    color: '#1c0202'
                },
                isMenuWaterfall: true
            },
            // {
            //     path: '/employee/:employeeId',
            //     component: () => import('@/pages/system/employee/EmployeeDetail'),
            //     isShow: false,
            //     name: 'employeeDetail',
            //     meta: {
            //         title: '员工详情',
            //         icon: 'beer'
            //     }
            // },
            {
                path: 'role',
                component: () => import('@/pages/system/role/RoleList'),
                // redirect: 'noredirect',
                name: 'role',
                id: 'system/role',
                meta: {
                    title: '角色管理',
                    icon: 'iconfont icon-other-jiaoseguanli3 bc-custom-menu',
                    color: '#5ef013'
                },
                isMenuWaterfall: true
            },
            {
                path: 'role-add',
                component: () => import('@/pages/system/role/RoleDetail'),
                isShow: false,
                name: 'roleAdd',
                id: 'system/role-add',
                meta: {
                    title: '添加角色',
                    icon: 'beer'
                },
                isMenuWaterfall: false
            },
            // {
            //     path: '/role/:roleId',
            //     component: () => import('@/pages/system/role/RoleDetail'),
            //     isShow: false,
            //     name: 'roleDetail',
            //     meta: {
            //         title: '角色详情',
            //         icon: 'beer'
            //     }
            // },
            {
                path: 'authority',
                component: () => import('@/pages/system/authority/AuthNav'),
                // redirect: 'noredirect',
                name: 'authority',
                id: 'system/authority',
                meta: {
                    title: '角色资源管理',
                    icon: 'iconfont icon-other-jiaosequanxian bc-custom-menu',
                    color: '#17b1df'
                },
                isMenuWaterfall: true
            },
            {
                path: 'roleResourceAuth',
                component: () => import('@/pages/system/authority/AuthorityList'),
                // redirect: 'noredirect',
                name: 'archive',
                id: 'system/roleResourceAuth',
                meta: {
                    title: '角色资源授权',
                    icon: 'table'
                },
                isMenuWaterfall: false
            },
            {
                path: 'role-assign',
                component: () => import('@/pages/system/role/RoleAssign'),
                name: 'role-assign',
                id: 'system/role-assign',
                meta: {
                    title: '员工角色管理',
                    icon: 'iconfont icon-other-jiaoseguanli bc-custom-menu',
                    color: '#bfca3a'
                },
                isMenuWaterfall: true
            },
            {
                path: 'organization',
                component: () => import('@/pages/system/organization/OrganizationView'),
                // redirect: 'noredirect',
                name: 'organization',
                id: 'system/organization',
                meta: {
                    title: '部门员工管理',
                    icon: 'iconfont icon-other-liucheng bc-custom-menu',
                    color: '#1378df'
                },
                isMenuWaterfall: true
            },
            {
                path: 'position-assign',
                component: () => import('@/pages/system/position/PositionAssign'),
                name: 'position-assign',
                id: 'system/position-assign',
                meta: {
                    title: '员工岗位管理',
                    icon: 'iconfont icon-other-jiaoseguanli2 bc-custom-menu',
                    color: '#e80aec'
                },
                isMenuWaterfall: true
            },
            {
                path: 'log',
                component: () => import('@/pages/system/log/LogList'),
                // redirect: 'noredirect',
                name: 'log',
                id: 'system/log',
                meta: {
                    title: '日志管理',
                    icon: 'iconfont icon-other-gengduo bc-custom-menu',
                    color: '#e6a23c'
                },
                isMenuWaterfall: true
            },
            {
                path: 'signatureFileList',
                component: () => import('@/pages/system/signatureFileList'),
                name: 'signatureFileList',
                id: 'system/signatureFileList',
                meta: {
                    title: '签章文件管理',
                    icon: 'iconfont icon-other-tubiaolunkuo_huaban bc-custom-menu',
                    color: '#e6a23c'
                },
                isMenuWaterfall: true
            },
            {
                path: 'appDataManager',
                component: () => import('@/pages/system/appDataManager'),
                name: 'appDataManager',
                id: 'system/appDataManager',
                meta: {
                    title: '应用数据管理',
                    icon: 'iconfont icon-other-zhushujushenqing-shujufenxi-05 bc-custom-menu',
                    color: '#e6a23c'
                },
                isMenuWaterfall: true
            },
            {
                path: 'specialResAuth',
                component: () => import('@/pages/system/authority/SpecialResAuth'),
                // redirect: 'noredirect',
                name: 'specialResAuth',
                id: 'system/specialResAuth',
                meta: {
                    title: '特殊权限资源管理',
                    icon: 'beer'
                },
                isMenuWaterfall: false
            }
            // ,{
            //     path: 'gateWayList',
            //     component: () => import('@/pages/system/gateWay/gateWayList'),
            //     name: 'gateWayList',
            //     id: 'system/gateWayList',
            //     meta: {
            //         title: '门户管理',
            //         icon: 'iconfont icon-other-gengduo bc-custom-menu',
            //         color: '#e6a23c'
            //     },
            //     isMenuWaterfall:true
            // },
        ]
    }
];



// WEBPACK FOOTER //
// ./src/router/modules/route-system.js